import "./OTARevenueManagementListings.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function OTARevenueManagementListingsPage() {
  return <div>
      <Header />
      <Hero />
      <Services />
      <Consultation />
      <Footer />
    </div>;
}